import React from 'react'
import {Caption, Col, H6} from '@modifi/ui'
import {OwnershipContainer, CompanyOwnershipType, HiddenInput, Label, StyledCol} from './styles'

type OwnershipTypeInputProps = {
  name: string
  value?: string
  disabled?: boolean
  onChange: (event: React.ChangeEvent<HTMLInputElement>, value: string) => void
  options: {
    label: React.ReactNode
    description: string
    value?: string | number | boolean
    icon: React.ReactElement
  }[]
}

const OwnershipTypeInput: React.FC<OwnershipTypeInputProps> = ({
  name,
  value = '',
  onChange,
  disabled = false,
  options,
}) => (
  <OwnershipContainer disabled={disabled} data-ident="radio-group" data-name={name}>
    {options.map(option => (
      <Col key={option.value as string} col={12} lg={8}>
        <Label>
          <HiddenInput
            type="radio"
            name={name}
            value={option.value as string}
            disabled={disabled}
            checked={value === option.value}
            onChange={e => onChange(e, e.target.value)}
          />
          <CompanyOwnershipType
            data-ident="ownershipStructureOption"
            data-target={option.value}
            isSelected={value === option.value}
            justifyContent="between"
            alignItems="center"
          >
            <Col md={9} alignSelf="stretch">
              <H6>{option.label}</H6>
              <Caption>{option.description}</Caption>
            </Col>
            <StyledCol md={3} mt={16} mdMt={0}>
              {option.icon}
            </StyledCol>
          </CompanyOwnershipType>
        </Label>
      </Col>
    ))}
  </OwnershipContainer>
)

export default OwnershipTypeInput
